import React from "react";
import { withTranslation } from "react-i18next";
import about1 from "../../assets/about1.jpg";
import Page from "../../components/Page";
import "./styles.css";

const index = ({ t }) => {
  return (
    <Page className="landing-page">
      <div className="aboutus">
        <h2 className="text-dark text-center mb-5">Website Terms of Use</h2>
        <h4 className="text-dark">Acceptance of the Terms of Use</h4>
        <p>
          Welcome to the website of faces2hire, Inc. ("Company" or "We"). The
          following terms and conditions, together with any documents they
          expressly incorporate by reference (collectively, these "Terms of
          Use"), govern your access to and use of faces2hire.com, including any
          content, functionality and services offered on or through
          faces2hire.com (the "Website"), whether as a guest or a registered
          user. <br />
          <br />
          Please read the Terms of Use carefully before you start to use the
          Website. By using the Website or by clicking to accept or agree to the
          Terms of Use when this option is made available to you, you accept and
          agree to be bound and abide by these Terms of Use and our Privacy
          Policy, incorporated herein by reference. If you do not want to agree
          to these Terms of Use or the Privacy Policy, you must not access or
          use the Website.
          <br />
          <br /> This Website is offered and available to users who are of legal
          working age in their jurisdiction of residence. By using this Website,
          you represent and warrant that you are of legal age to form a binding
          contract with the Company and meet all of the foregoing eligibility
          requirements. If you do not meet all of these requirements, you must
          not access or use the Website.
        </p>
        <br />
        <h4 className="text-dark">Changes to the Terms of Use</h4>
        <p>
          We may revise and update these Terms of Use from time to time in our
          sole discretion. All changes are effective immediately when we post
          them, and apply to all access to and use of the Website thereafter.
          However, any changes to the dispute resolution provisions set forth in
          Governing Law and Jurisdiction will not apply to any disputes for
          which the parties have actual notice prior to the date the change is
          posted on the Website.
          <br />
          <br />
          Your continued use of the Website following the posting of revised
          Terms of Use means that you accept and agree to the changes. You are
          expected to check this page each time you access this Website so you
          are aware of any changes, as they are binding on you.
        </p>
        <h4 className="text-dark">
          Accessing the Website and Account Security
        </h4>
        <p>
          We reserve the right to withdraw or amend this Website, and any
          service or material we provide on the Website, in our sole discretion
          without notice. We will not be liable if for any reason all or any
          part of the Website is unavailable at any time or for any period. From
          time to time, we may restrict access to some parts of the Website, or
          the entire Website, to users, including registered users.
          <br />
          <br />
          You are responsible for:
          <ul>
            <li>
              Making all arrangements necessary for you to have access to the
              Website.
            </li>
            <li>
              Ensuring that all persons who access the Website through your
              internet connection are aware of these Terms of Use and comply
              with them.
            </li>
          </ul>
          To access the Website or some of the resources it offers, you may be
          asked to provide certain registration details or other information. It
          is a condition of your use of the Website that all the information you
          provide on the Website is correct, current and complete. You agree
          that all information you provide to register with this Website or
          otherwise, including but not limited to through the use of any
          interactive features on the Website, is governed by our Privacy
          Policy, and you consent to all actions we take with respect to your
          information consistent with our Privacy Policy.
          <br />
          <br />
          If you choose, or are provided with, a user name, password or any
          other piece of information as part of our security procedures, you
          must treat such information as confidential, and you must not disclose
          it to any other person or entity. You also acknowledge that your
          account is personal to you and agree not to provide any other person
          with access to this Website or portions of it using your user name,
          password or other security information. You agree to notify us
          immediately of any unauthorized access to or use of your user name or
          password or any other breach of security. You also agree to ensure
          that you exit from your account at the end of each session. You should
          use particular caution when accessing your account from a public or
          shared computer so that others are not able to view or record your
          password or other personal information.
          <br />
          <br />
          We have the right to disable any user name, password or other
          identifier, whether chosen by you or provided by us, at any time in
          our sole discretion for any or no reason, including if, in our
          opinion, you have violated any provision of these Terms of Use.
        </p>
        <h4 className="text-dark">Intellectual Property Rights</h4>
        <p>
          The Website and its entire contents, features and functionality
          (including but not limited to all information, software, text,
          displays, images, video and audio, and the design, selection and
          arrangement thereof), are owned by the Company, its licensors or other
          providers of such material and are protected by United States and
          international copyright, trademark, patent, trade secret and other
          intellectual property or proprietary rights laws.
          <br />
          <br />
          These Terms of Use permit you to use the Website for your personal or
          allowable commercial use (solely if an employer-user of the Website).
          You must not reproduce, distribute, modify, create derivative works
          of, publicly display, publicly perform, republish, download, store or
          transmit any of the material on our Website, except as follows:
          <br />
          <br />
          <ul>
            <li>
              Your computer may temporarily store copies of such materials in
              RAM incidental to your accessing and viewing those materials.
            </li>
            <li>
              You may store files that are automatically cached by your Web
              browser for display enhancement purposes.
            </li>
            <li>
              You may print or download one copy of a reasonable number of pages
              of the Website for your own personal, non-commercial use and not
              for further reproduction, publication or distribution.
            </li>
            <li>
              If we provide desktop, mobile or other applications for download,
              you may download a single copy to your computer or mobile device
              solely for your own personal, non-commercial use, provided you
              agree to be bound by our end user license agreement for such
              applications.
            </li>
            <li>
              If we provide social media features with certain content, you may
              take such actions as are enabled by such features.
            </li>
          </ul>
          <br />
          <br />
          You must not access or use for any commercial purposes any part of the
          Website or any services or materials available through the Website.
          <br />
          <br />
          If you wish to make any use of material on the Website other than that
          set out in this section, please address your request to:
          support@faces2hire.com.
          <br />
          <br />
          If you print, copy, modify, download or otherwise use or provide any
          other person with access to any part of the Website in breach of the
          Terms of Use, your right to use the Website will cease immediately and
          you must, at our option, return or destroy any copies of the materials
          you have made. No right, title or interest in or to the Website or any
          content on the Website is transferred to you, and all rights not
          expressly granted are reserved by the Company. Any use of the Website
          not expressly permitted by these Terms of Use is a breach of these
          Terms of Use and may violate copyright, trademark and other laws.
        </p>
        <h4 className="text-dark">Trademarks</h4>
        <p>
          The Company name, the terms: Faces 2 hire (issued), faces2hire
          (issued), Get Noticed- Get Hired (issued), and "A picture is worth a
          thousand words, and a video is even better" (issued), and the
          Company’s logos utilized on the Website, and all related names, logos,
          product and service names, designs and slogans are trademarks of the
          Company or its affiliates or licensors. You must not use such marks
          without the prior written permission of the Company. All other names,
          logos, product and service names, designs and slogans on this Website
          are the trademarks of their respective owners.
        </p>
        <h4 className="text-dark">User Contributions</h4>
        <p>
          The Website may contain message boards, chat rooms, personal web pages
          or profiles, forums, bulletin boards[, LIST ANY OTHER INTERACTIVE
          FEATURES] and other interactive features (collectively, "Interactive
          Services") that allow users to post, submit, publish, display or
          transmit to other users or other persons (hereinafter, "post") content
          or materials (collectively, "User Contributions") on or through the
          Website.
          <br />
          <br />
          All User Contributions must comply with the Content Standards set out
          in these Terms of Use.
          <br />
          <br />
          Any User Contribution you post to the site will be considered
          non-confidential and non-proprietary. By providing any User
          Contribution on the Website, you grant us and our affiliates and
          service providers, and each of their and our respective licensees,
          successors and assign the right to use, reproduce, modify, perform,
          display, distribute and otherwise disclose to third parties any such
          material according to your account settings.
          <br />
          <br />
          You represent and warrant that: • You own or control all rights in and
          to the User Contributions and have the right to grant the license
          granted above to us and our affiliates and service providers, and each
          of their and our respective licensees, successors and assigns. • All
          of your User Contributions do and will comply with these Terms of Use.
          <br />
          <br />
          You understand and acknowledge that you are responsible for any User
          Contributions you submit or contribute, and you, not the Company, have
          full responsibility for such content, including its legality,
          reliability, accuracy and appropriateness.
          <br />
          <br />
          We are not responsible, or liable to any third party, for the content
          or accuracy of any User Contributions posted by you or any other user
          of the Website.
        </p>
      </div>
    </Page>
  );
};

export default withTranslation()(index);
